import { useLegalEntityRegions } from '../../../hooks/useUser';
import { RegionFilter } from '../../../components/RegionFilter';

export const MailRegionFilter = () => {
  const regions = useLegalEntityRegions();
  return (
    <RegionFilter
      regions={regions}
      ariaButtonText="Change mail location filter:"
      menuItemLabelPrefix="Filter mail to"
    />
  );
};
